
<template>
  <v-container fluid grid-list-xl page>

    <!-- Your contet -->

    <div class="display-2 grey--text text--darken-1">API de Integración</div>
    <div
      class="title grey--text text--darken-1"
    ></div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md12 lg12 offset-2>
                <v-card flat tile>
                  <v-img justify-center src="/static/send.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Integra los servicios de Securyty en tu solución </h3>
                      <div> Securyty ofrece una una API REST que permite de forma sencilla la integración con cualquier solución, tanto a nivel de Front como de Backend. Con muy poco  esfuerzo de desarrollo tendrás acceso a toda la funcionalidad ofrecida por nuestra plataforma , tanto para iniciar procesos de firma como para la ejecución de los mismos y la obtención de información en tiempo real.  </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md12 lg12>
                <v-card flat tile>
                  <v-img src="/static/digital-signature.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Acceso a las distintas funcionalidades</h3>
                      <div>Puedes componer una solución a medida utilizando los componentes quee elijas:  
                        <ul>
                          <li>Firma electrónica de diversos tipos</li>
                          <li>Notificación certificadas</li>
                          <li>Identificación de personas</li>
                          <li>Validación de documentos y OCR </li>
                        </ul>
                        </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <v-flex xs12 md12 lg12>
                <v-card flat tile>
                  <v-img s src="/static/2devices.png" width="100" aspect-ratio="1"></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Integrable en tus páginas web</h3>
                      <div>Securyty ofrece una librería de componentes que puedes utilizar para embeber el proceso de firma en cualquier página web de etus procesos</div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>





            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>

  
  


<v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Gracias</v-card-title>

        <v-card-text>
          Hemos recibido tu petición. En breve nos pondremos en contacto contigo.
          
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>



          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<v-layout height="100" >
  <v-card height="100" flat color="grey">
  </v-card>
</v-layout>

        
    <v-dialog v-model="isCreateSign" persistent max-width="500px" >
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Create New Identification </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon
                slot="activator"
                color="white"
                dark
              >help_outline</v-icon>
            <span><b>Identity Verification : <br><br>- Identify through a video, view the result and sign a document with the data extracted from the identification</b><br><br>
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-video-page :scrollTop=scrollTop signatureType="video"></create-sign-video-page>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click.native="closeSignaturePage">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
  </v-container>
</template>

<script>
import CreateSignVideoPage from "./CreateSignVideoPage";

export default {
  components: {
    CreateSignVideoPage
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isCreateSign: false,
      page: {
        title: "Key Features ",
        headline: "Key Features",
        description: `Automate your on-boarding process`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    },
    goToLegal() {
      this.$router.push({ name: "legalInformationEs" });
    }
  }
};
</script>
